export default {
  siteIdentity: {
    logo: {
      url: 'https://media.immediate.co.uk/volatile/sites/10/2022/05/Gardeners-World-Logo-Horizontal-Black-6e80d39.png',
      alt: 'Gardeners World Logo',
      width: 379,
      height: 30.85
    },
    secondaryLogo: {
      url: 'https://media.immediate.co.uk/volatile/sites/10/2022/05/Gardeners-World-Logo-Stacked-White-352eda6.png',
      alt: 'Gardeners World logo',
      width: 212,
      height: 66
    },
    mobileLogo: {
      url: 'https://media.immediate.co.uk/volatile/sites/10/2022/05/Gardeners-World-Logo-Stacked-White-352eda6.png',
      alt: 'Gardeners World logo',
      width: 120,
      height: 37.75
    }
  }
};